import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";

export const useRequestActions = (setItems) => {
  const toggle = async (request) => {
    const status = request.status === "traite" ? "nouveau" : "traite";
    try {
      await axios.patch(`${API}/requests/${request.id}`, { status }, { withCredentials: true });
      setItems((items) => items.map((item) => item.id === request.id ? { ...item, status } : item));
      toast.success(status === "traite" ? "Marquée comme traitée" : "Remise en nouvelle");
    } catch { toast.error("Mise à jour impossible"); }
  };

  const remove = async (request) => {
    if (!window.confirm(`Supprimer la demande de ${request.name} ? Action définitive.`)) return;
    try {
      await axios.delete(`${API}/requests/${request.id}`, { withCredentials: true });
      setItems((items) => items.filter((item) => item.id !== request.id));
      toast.success("Demande supprimée");
    } catch { toast.error("Suppression impossible"); }
  };
  return { toggle, remove };
};